import { LightPosition } from './scenario-image';
import {ProductType} from "./product";
import {SmallProductType} from "../services/product-type/product-type";

export enum DoorType {
  SINGLE = 'SINGLE',
  DOUBLE = 'DOUBLE',
  GARAGE = 'GARAGE',
  GARAGE_DOUBLE = 'GARAGE_DOUBLE',
  INTERIOR = 'INTERIOR',
  INTERIOR_DOUBLE = 'INTERIOR_DOUBLE',
  ENTRY = 'ENTRY',
  PATIO = 'PATIO',
  GLIDING = 'GLIDING',
  FLOOR = 'FLOOR',
  FRONT = 'FRONT',
  EXTERIOR = 'EXTERIOR',
  EXTERIOR_DOUBLE = 'EXTERIOR_DOUBLE',
  ENTRY_WITH_SIDELIGHT = 'ENTRY_WITH_SIDELIGHT',
  SECURITY = 'SECURITY',
  GATE = 'GATE',
}

export function getDoorTypeIcon(doorType: DoorType): string | undefined {
  switch (doorType) {
    case DoorType.SINGLE:
      return 'utils/single-door.svg'
    case DoorType.FLOOR:
      return 'utils/floors-icon.svg'
    case DoorType.DOUBLE:
      return 'utils/double-door.svg'
    case DoorType.GARAGE:
      return 'utils/garage-single-icon.svg'
    case DoorType.GARAGE_DOUBLE:
      return 'utils/garage-double-icon.svg'
    default:
      return undefined
  }
}

export function getDoorTypeLabel(doorType: DoorType) {
  switch (doorType) {
    case DoorType.SINGLE:
      return 'Single'
    case DoorType.FLOOR:
      return 'Floors'
    case DoorType.DOUBLE:
      return 'Double'
    case DoorType.GARAGE_DOUBLE:
      return 'Double Door' // Requested by overheaddoor
    case DoorType.GARAGE:
      return 'Single Door' // Requested by overheaddoor
    case DoorType.INTERIOR:
      return 'Interior'
    case DoorType.INTERIOR_DOUBLE:
      return 'Interior Double'
    case DoorType.EXTERIOR:
      return 'Exterior'
    case DoorType.EXTERIOR_DOUBLE:
      return 'Exterior Double'
    case DoorType.ENTRY_WITH_SIDELIGHT:
      return 'Entry with Sidelight'
    case DoorType.SECURITY:
      return 'Security'
    case DoorType.GATE:
      return 'Gate'
    default:
      // Return first letter capitalized
      return doorType.charAt(0).toUpperCase() + doorType.slice(1)
  }
}

export interface Door {
  id: string;
  externalIds: Array<string>;
  imageUrl: string;
  thumbnailUrl: string;
  doorType: SmallProductType;
  productPageUrl: string;
  isFavorite: boolean;
  customData?: string;
  name: string;
  shadowImageUrls?: Map<LightPosition, string>;
  price?: {
    value: number,
    currency: string
  };
  productType: ProductType
}
